import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {_SettingsService} from "../../../services/settings.service";
import {_GridService} from "../../../ng1-services/grid.service";
import {jqxGridComponent} from "../../../../assets/jqwidgets-ts/angular_jqxgrid";
import {Grid} from "../../../interfaces/grid.interface";
import {Observable} from "rxjs/Observable";

declare var $: any, dump: any;

@Component({
  selector: 'security-quantity-ratio',
  templateUrl: './security-quantity-ratio.component.html',
  styleUrls: ['./security-quantity-ratio.component.css'],
})

export class SecurityQuantityRatioBranch implements OnInit, OnDestroy {

  private $observable: Observable<any>;
  private subscription: any;

  @ViewChild('securityQuantityRatioGrid') securityQuantityRatioGrid: jqxGridComponent;
  private securityQuantityRatioSettings: Grid;

  constructor (private titleService: Title, private settingService: _SettingsService, private gridservice: _GridService) {}

  ngOnInit(){
    this.titleService.setTitle("WiseRisk | Security Quantity Ratio Settings");
    this.getSecurityQuantityRatios();
  }

  getSecurityQuantityRatios(){
    this.securityQuantityRatioSettings = null;
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    this.$observable = this.settingService.GetSecurityQuantityRatios();
    this.subscription = this.$observable.subscribe(
      result => this.loadSecurityQuantityRatios(result)
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  loadSecurityQuantityRatios(securityQuantityRatios) {
    let msgContainer = "securityQuantityRatioMsg";
    var source = {
      datatype: 'json',
      localdata: securityQuantityRatios,
      datafields: [
        {
          name: 'assetQuantityRatioId',
          type: 'string'
        }, {
          name: 'organizationId',
          type: 'string'
        }, {
          name: 'externalSecurityId',
          type: 'string'
        }, {
          name: 'quantityRatio',
          type: 'string'
        }, {
          name: 'alternateCurrency',
          type: 'string'
        }
      ],
      updaterow: (rowid, rowdata, commit) => {
        if (rowdata.rowId < 1) {
          this.settingService.CreateSecurityQuantityRatio(rowdata).subscribe(data => {
            this.gridservice.SuccessMsg(msgContainer, 'Security Quantity Ratio Added');
            this.getSecurityQuantityRatios();
          }, data => {
            this.gridservice.ErrorMsg(msgContainer, data);
          });
        } else {
          this.settingService.UpdateSecurityQuantityRatio(rowdata).subscribe(data => {
            this.gridservice.SuccessMsg(msgContainer, 'Security Quantity Ratio Updated');
            this.getSecurityQuantityRatios();
          }, data => {
            this.gridservice.ErrorMsg(msgContainer, data);
          });
        }
      },
      deleterow: (rowdata) => {
        this.settingService.DeleteSecurityQuantityRatio(rowdata.assetQuantityRatioId).subscribe(data => {
          this.gridservice.SuccessMsg(msgContainer, 'Security Quantity Ratio Deleted');
          this.getSecurityQuantityRatios();
        }, data => {
          this.gridservice.ErrorMsg(msgContainer, data);
        });
      },
      refresh: () => {
        this.getSecurityQuantityRatios();
      },
      getGrid: () => {
        return this.securityQuantityRatioGrid;
      }
    };
    this.securityQuantityRatioSettings = {
      source: source,
      dataAdapter: new $.jqx.dataAdapter(source),
      columns: [
        {
          text: 'External Security Id',
          columntype: 'textbox',
          datafield: 'externalSecurityId'
        }, {
          text: 'Alternate Currency',
          columntype : 'dropdownlist',
          datafield : 'alternateCurrency',
          width : '150',
          createeditor : (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source : this.gridservice.GetCurrencyDataAdapter(false, false),
              displayMember : "currency",
              valueMember : "currency"
            });
          }
        }, {
          text: 'Quantity Ratio',
          columntype: 'textbox',
          datafield: 'quantityRatio'
        }
      ],
      renderstatusbar: (statusbar: any) => {
        this.gridservice.RenderStatusBar(statusbar, source);
      }
    };
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/security-quantity-ratio/security-quantity-ratio.component.ts